import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // <--- 1. Add Link here
import api from '../api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!username || !password) {
      setError("Please enter both username and password.");
      setLoading(false);
      return;
    }

    try {
      console.log("Sending credentials for:", username);
      const res = await api.post('token/', { username, password });

      console.log("Login Success!");

      localStorage.setItem('access_token', res.data.access);
      localStorage.setItem('refresh_token', res.data.refresh);
      localStorage.setItem('username', username);

      window.location.href = '/dashboard';

    } catch (err) {
      console.error("Login Failed:", err);
      if (err.response && err.response.status === 401) {
        setError("❌ Invalid Username or Password.");
      } else {
        setError("⚠️ Server error. Is the backend running?");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '100px' }}>
      <div className="card">
        <h2 style={{ textAlign: 'center' }}>SiteACT Login</h2>
        
        {error && (
          <div style={{ backgroundColor: '#fca5a5', color: '#7f1d1d', padding: '10px', borderRadius: '4px', marginBottom: '10px', textAlign:'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Verifying...' : 'Sign In'}
          </button>
          
          {/* <--- 2. Add this block for the link */}
          <div style={{ marginTop: '15px', textAlign: 'center' }}>
             <Link to="/forgot-password" style={{ color: '#3b82f6', textDecoration: 'none', fontSize: '0.9rem' }}>
                Forgot your password?
             </Link>
          </div>

        </form>
      </div>
    </div>
  );
};

export default Login;